import { createFileRoute } from "@tanstack/react-router";

import { OnboardingJobDetailPage } from "@/pages/Sales";

export const Route = createFileRoute("/app/admin/investor-onboarding-jobs/$job_id")({
  component: AdminOnboardingJobDetailRoute,
});

function AdminOnboardingJobDetailRoute() {
  const { job_id } = Route.useParams();
  return (
    <OnboardingJobDetailPage
      jobId={job_id}
      variant="admin"
    />
  );
}
